module.exports = "/fast-coin/img/coin/anim/in/coin_in_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_025.png
// module id = 2295
// module chunks = 5